import { ReactNode } from "react";
import { jotaiStore } from "../../utils/jotaiStore";
import { Provider } from "jotai";

export const JotaiProvider = ({ children }: { children: ReactNode }) => (
  <Provider store={jotaiStore}>{children}</Provider>
);
